module.exports = __webpack_public_path__ + "assets/img/4.8edae583.png";